/**
 * A JSON (or plain-string) value, rendered read-only.
 *
 * `label` is optional: the audit-log detail panel stacks labelled blocks, while
 * a table cell already has its column header and passes none.
 */
const JsonViewer = ({ label, value }) => (
  <div>
    {label && <div className="text-[11px] font-semibold text-text-primary/60 uppercase tracking-wide mb-1">{label}</div>}
    {value === null || value === undefined || value === "" ? (
      <div className="text-xs text-text-primary/40 italic">—</div>
    ) : (
      <pre
        className="text-[11px] bg-background-tertiary border border-border-primary rounded-lg p-3 overflow-x-auto whitespace-pre-wrap break-words max-h-64 overflow-y-auto"
        title={typeof value === "string" ? value : JSON.stringify(value)}
      >
        {typeof value === "string" ? value : JSON.stringify(value, null, 2)}
      </pre>
    )}
  </div>
);

export default JsonViewer;
